import PropTypes from 'prop-types';
import { Popover } from 'mui/core';
import BaseMenuItem from './BaseMenuItem';

const MenuItemWithPopover = ({
                               icon,
                               label,
                               onClick,
                               popoverOptions,
                               anchorEl,
                               setAnchorEl,
                               isLoading,
                               isSuccess,
                               isFailed,
                             }) => {
  const open = Boolean(anchorEl);

  return <>
    <BaseMenuItem
      icon={icon}
      label={label}
      onClick={(event) => {
        setAnchorEl(event.currentTarget);
        onClick?.call(this, event);
      }}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isFailed={isFailed}
    />
    {
      popoverOptions && <Popover
        id={'Filter settings popover'}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        // Token-driven paper so the popover follows theme — the inner
        // card below already paints its own border/radius, but the
        // MUI Paper underneath defaults to white and shows through as
        // a glaring rectangle on dark backgrounds without this. MUI v9
        // routes paper styling through `slotProps.paper`.
        slotProps={{
          paper: {
            sx: {
              backgroundColor: 'var(--qhs-surface)',
              color: 'var(--qhs-text-1)',
            },
          },
        }}
      >
        <div style={{
          padding: 12,
          // Border was hardcoded `rgb(217, 217, 217)` — token swap so
          // the divider follows light/dark theme.
          border: '1px solid var(--qhs-border)',
          borderRadius: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}>
          {popoverOptions}
        </div>
      </Popover>
    }
  </>;
};

MenuItemWithPopover.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  popoverOptions: PropTypes.element,
};

export default MenuItemWithPopover;
